/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetPromotionCustomerCandidates200ResponseItemsInner } from './GetPromotionCustomerCandidates200ResponseItemsInner';
import {
    GetPromotionCustomerCandidates200ResponseItemsInnerFromJSON,
    GetPromotionCustomerCandidates200ResponseItemsInnerFromJSONTyped,
    GetPromotionCustomerCandidates200ResponseItemsInnerToJSON,
    GetPromotionCustomerCandidates200ResponseItemsInnerToJSONTyped,
} from './GetPromotionCustomerCandidates200ResponseItemsInner';

/**
 * 
 * @export
 * @interface GetPromotionCustomerCandidates200Response
 */
export interface GetPromotionCustomerCandidates200Response {
    /**
     * 
     * @type {Array<GetPromotionCustomerCandidates200ResponseItemsInner>}
     * @memberof GetPromotionCustomerCandidates200Response
     */
    items: Array<GetPromotionCustomerCandidates200ResponseItemsInner>;
    /**
     * 
     * @type {number}
     * @memberof GetPromotionCustomerCandidates200Response
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof GetPromotionCustomerCandidates200Response
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof GetPromotionCustomerCandidates200Response
     */
    itemsPerPage: number;
}

/**
 * Check if a given object implements the GetPromotionCustomerCandidates200Response interface.
 */
export function instanceOfGetPromotionCustomerCandidates200Response(value: object): value is GetPromotionCustomerCandidates200Response {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('itemsPerPage' in value) || value['itemsPerPage'] === undefined) return false;
    return true;
}

export function GetPromotionCustomerCandidates200ResponseFromJSON(json: any): GetPromotionCustomerCandidates200Response {
    return GetPromotionCustomerCandidates200ResponseFromJSONTyped(json, false);
}

export function GetPromotionCustomerCandidates200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPromotionCustomerCandidates200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(GetPromotionCustomerCandidates200ResponseItemsInnerFromJSON)),
        'total': json['total'],
        'page': json['page'],
        'itemsPerPage': json['itemsPerPage'],
    };
}

export function GetPromotionCustomerCandidates200ResponseToJSON(json: any): GetPromotionCustomerCandidates200Response {
    return GetPromotionCustomerCandidates200ResponseToJSONTyped(json, false);
}

export function GetPromotionCustomerCandidates200ResponseToJSONTyped(value?: GetPromotionCustomerCandidates200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(GetPromotionCustomerCandidates200ResponseItemsInnerToJSON)),
        'total': value['total'],
        'page': value['page'],
        'itemsPerPage': value['itemsPerPage'],
    };
}

